/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function MastercardWhite(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'MastercardWhite',
      'aria-hidden': true,
      focusable: false,
      width:  35 * scale,
      height: 25 * scale,
      viewBox: '0 0 35 25',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"35","height":"25","fill":"#FFF","rx":"3.316"}),createElement('path', {"fill":"#FF5E00","d":"M17.684 7.373a6.74 6.74 0 0 1 4.421-1.649c3.764 0 6.816 3.09 6.816 6.903s-3.052 6.903-6.816 6.903c-1.687 0-3.23-.62-4.42-1.65a6.74 6.74 0 0 1-4.422 1.65c-3.764 0-6.816-3.09-6.816-6.903s3.052-6.903 6.816-6.903c1.687 0 3.23.62 4.421 1.649"}),createElement('path', {"fill":"#ED0006","d":"M17.684 7.373a6.92 6.92 0 0 0-2.395 5.254c0 2.104.93 3.988 2.395 5.254a6.74 6.74 0 0 1-4.421 1.649c-3.764 0-6.816-3.09-6.816-6.903s3.052-6.903 6.816-6.903c1.687 0 3.23.62 4.421 1.649"}),createElement('path', {"fill":"#F9A000","d":"M17.684 17.88a6.92 6.92 0 0 0 2.395-5.253c0-2.104-.93-3.988-2.395-5.254a6.74 6.74 0 0 1 4.421-1.649c3.764 0 6.816 3.09 6.816 6.903s-3.052 6.903-6.816 6.903c-1.687 0-3.23-.62-4.42-1.65z"})))
}
